import createSymbol from 'lib/core/createSymbol';

const createAlertsSymbol = createSymbol('LCRMT_HOURLY_ALERTS');

export default {
  // cancel call
  CANCEL_HOURLY_ALERT_SDK_CALL: createAlertsSymbol('CANCEL_HOURLY_ALERT_SDK_CALL')
};
